<!-- 트랜드1형 뷰 컴포넌트 -->
<template>
    <div class="equip-chart-view" style="height: 50rem">
        <Draggable
            v-if="!isEmpty(responseChart) && isChartLoading"
            v-model="responseChart"
            class="row justify-content-center align-items-center"
            @change="$emit('update-chart-order')"
            @start="$emit('on-drag-start', $event)"
            @end="$emit('on-drag-end', $event)"
            tag="div"
            :disabled="!dragMode"
        >
            <div
                v-for="(data, index) in responseChart"
                :key="data.key"
                @click="data.data.datasets[0].ptIdx ? $emit('click-mix-chart', data.data.datasets[0].ptIdx) : null"
                :class="[
                    chartColumn,
                    { dragging: isDragging && dragIndex === index },
                    data.data.datasets[0].ptIdx ? 'pointer-cursor' : '',
                ]"
                :style="{ height: '270px' }"
            >
                <MixChart
                    :chartData="data.data"
                    :options="data.option"
                    :datasets="data.datasets"
                    :style="{ height: '100%', padding: '15px' }"
                />
            </div>
        </Draggable>
        <div
            v-else-if="isEmpty(responseChart) && isChartLoading"
            class="empty-state"
            style="
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            "
        >
            <span class="detail-notification-icon">
                <i class="fas fa-exclamation-circle"></i>
            </span>
            <span class="detail-notification-text">표시할 데이터가 없습니다.</span>
        </div>
        <div
            v-else
            class="loading-state"
            style="
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            "
        >
            <b-spinner class="secondary"></b-spinner>
        </div>
    </div>
</template>

<script>
import MixChart from "@src/components/vue-chartjs/NewMixChart";
import Draggable from "vuedraggable";

export default {
    name: "EquipChartView",
    components: {
        MixChart,
        Draggable,
    },
    props: {
        responseChart: {
            type: Array,
            default: () => [],
        },
        isChartLoading: {
            type: Boolean,
            default: false,
        },
        dragMode: {
            type: Boolean,
            default: false,
        },
        chartColumn: {
            type: String,
            default: "col-md-11",
        },
        isDragging: {
            type: Boolean,
            default: false,
        },
        dragIndex: {
            type: Number,
            default: null,
        },
    },
    emits: ["update-chart-order", "on-drag-start", "on-drag-end", "click-mix-chart"],
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/_detail-common.scss";

.equip-chart-view {
    /* 스타일은 필요시 추가 */
}

.pointer-cursor {
    cursor: pointer;
}

.dragging {
    border: 1px solid #333333aa;
    border-radius: 10px;
    background-color: #33333311;
}
</style>
